import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NewVulnerabilityService } from 'src/app/Data Service/new-vulnerability.service';
import { UpdateAssessClass } from 'src/app/Data Service/UpdateAssessClass';
import { UpdateQuesRes } from './UpdateQuesRes';
import { NgxSpinnerService } from "ngx-spinner";
import{IUserView} from './IUserView'
import { IQuesRes } from './IQuesRes';
@Component({
  selector: 'app-user-view-assessment',
  templateUrl: './user-view-assessment.component.html',
  styleUrls: ['./user-view-assessment.component.css']
})
export class UserViewAssessmentComponent  {

//#region  Global declarations 
objAssClass=new IUserView();
AssessDDdata:any;
EID:any;
productForm: UntypedFormGroup; 
errormessage: any;
disableSelect: boolean;
//#endregion

constructor(private spinner: NgxSpinnerService,private fb:UntypedFormBuilder,private service : NewVulnerabilityService, private _route : ActivatedRoute
  ,private _router : Router) {
 
  this.productForm = this.fb.group({
    quantities: this.fb.array([this.newQuantity()]) ,
  });
}

ngOnInit(): void {    
  let AID=this._route.snapshot.params.id; 
  if(AID !=0)
  {
    this.getAssessData(AID);
  }    
  else{
    alert("Please provide a valid ID!");
    this._router.navigate(['/home']);
  }
  this.disableSelect = true;

}

getAssessData(AID : any){
  this.spinner.show();
  this.service.getAssessDataList(AID).subscribe(
    (data : any)=>{  
      this.objAssClass=data[0];        
      this.productForm.setControl("quantities", this.SetQtyValue(data));
      this.spinner.hide();
    }, (error:any) => {        
      this.errormessage = error;
    }
  )    
}

SetQtyValue(qtySet : IQuesRes[]): UntypedFormArray{
  const formmarray = new UntypedFormArray([]);
  qtySet.forEach(s => {
    formmarray.push(this.fb.group({
      QuestionID:s.QuestionID,
      Question: s.Question ,
          Response:s.Response ,
    }));
  });    
  return formmarray;
}

quantities() : UntypedFormArray {
  return this.productForm.get("quantities") as UntypedFormArray
}
 
//it will return form group with the required field to be inserted
newQuantity(): UntypedFormGroup {
  return this.fb.group({
    QuestionID:[''],
    Question: [''],
    Response: ['']    
  })
}

AddAssessment(objAssess : IUserView){
  let assessVal : Array<UpdateQuesRes>=[];
  for(let j=0;j<this.productForm.controls["quantities"].value.length;j++){
    var assessArrVal = new UpdateQuesRes();
    assessArrVal.QuestionID = this.productForm.controls["quantities"].value[j].QuestionID;
    assessArrVal.Question = this.productForm.controls["quantities"].value[j].Question;
    assessArrVal.Response = this.productForm.controls["quantities"].value[j].Response;
    assessVal.push(assessArrVal);
  }
  // this.Eid = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));
  this.EID="shyam.valath.suresh";    
  var val  = {
    DateRaised : objAssess.DateRaised,
              Client : objAssess.ClientName,
              Contract : objAssess.ContractNumber,
              ContractName : objAssess.ContractName,
              TitleAssess : objAssess.AssessmentName,
              QuesRes : assessVal,              
              LastUpdatedBy:this.EID,                           
            };                      
             this.service.UpdateAssessment(val).subscribe(res => {
               console.log(res.toString());
              if(res.toString() == "Updated Successfully!"){
                alert("Updated Successfully!");
                this._router.navigate(['/home']);
              }
               
          }, (error:any) => {
            this.errormessage = error;
            alert("Updated Failed!");
        });    
}


onSubmit(){  
  this.AddAssessment(this.objAssClass);  
}
onCancel(){
  this._router.navigate(['/home']);
}

}

